import styled from 'styled-components';

import Text from '~components/Text';
import { getFontStyle } from '~components/Text/helper';

export const ChartSectionWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const ChartTitle = styled(Text)`
  width: 100%;
  margin-bottom: 4px;
  text-align: center;
  word-break: keep-all;
`;
export const ChartContent = styled.li`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Legend = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }

  span {
    color: ${({ theme }) => theme.colors.gray700};
    ${getFontStyle('midium150_B3')}
  }
`;
